import React from "react";

interface Props extends React.DetailedHTMLProps<React.TableHTMLAttributes<HTMLTableElement>, HTMLTableElement> {}

const Table: React.FC<Props> = ({ className = "table", children, ...props }) => {
    return (
        <div className="relative w-full overflow-auto">
            <table className={className} {...props}>
                {children}
            </table>
        </div>
    );
};

export default Table;
